import { Credentials } from "./ICredentials";

export namespace Users {
  export interface IUser {
    id: number;
    credentialsId: number;
    credentials: Credentials.ICredentials;
    status: number;
  }

  export class User implements IUser {
    id: number = 0;
    credentialsId: number = 0;
    credentials: Credentials.ICredentials = new Credentials.Credentials();
    status: number = 0;
  }
}
